<template>
    <Head :title="translate('order.teaser:headlines').join(' ')" />
    <div class="mx-auto max-w-3xl pb-8" style="min-height: 50vh">
        <div class="px-4 sm:px-10 sm:text-center max-w-6xl md:mx-auto lg:text-left">
            <div>
                <Teaser v-if="!redirect" :headlines="translate('order.teaser:headlines')"></Teaser>
                <Teaser v-if="redirect" :headlines="translate('order.teaser:headlines-redirect')"></Teaser>
            </div>
        </div>
        <div class="mt-8">
            <div class="bg-white sm:w-full max-w-3xl sm:mx-auto sm:overflow-hidden">
                <RegistrationConfirmedBox v-if="!redirect" :existingUser="existingUser" :nft="nft" :buyUrl="buyUrl" :billing-provider="billingProvider"></RegistrationConfirmedBox>
                <RegistrationConfirmedRedirectBox v-if="redirect" :existingUser="existingUser" :nft="nft" :buyUrl="buyUrl" :billing-provider="billingProvider"></RegistrationConfirmedRedirectBox>
            </div>
        </div>
        <Steps :step="3"></Steps>

    </div>

</template>

<script>
import FAQ from './../../../Components/FAQ';
import Steps from './../../../Components/Steps';
import RegistrationConfirmedBox from './../../../Components/Auth/RegistrationConfirmedBox';
import RegistrationConfirmedRedirectBox from './../../../Components/Auth/RegistrationConfirmedRedirectBox';
import {Head, usePage} from '@inertiajs/inertia-vue3'
import {onMounted} from "vue";
import Teaser from "../../../Components/Common/Teaser";
import translate from "../../../../lang";


export default {
    components: {
        Teaser,
        FAQ,
        RegistrationConfirmedBox,
        RegistrationConfirmedRedirectBox,
        Steps,
        Head,
    },
    props: {
        nft: Object,
        buyUrl: String,
        existingUser: Boolean,
        billingProvider: String,
        autoRedirect: Boolean,
    },
    setup(props) {
        onMounted(() => {
            gtagAds('event', 'conversion', {'send_to': 'AW-10863969210/LjkyCM-d17EDELqHrLwo'});
        });
        return {
            onMounted,
            redirect: props.autoRedirect,
            translate: translate('upload-' + usePage().props.value.metaDataType.type)
        }
    }
}
</script>
